import { inject, Injectable } from '@angular/core';

import { UpdateUserSupportingCompanyOpts } from '@interfaces';
import { AppState } from '@state';
import { Store } from '@ngrx/store';

import * as uscActions from './user-supporting-company.actions';
import * as uscSelectors from './user-supporting-company.selectors';
import { Actions, ofType } from '@ngrx/effects';

@Injectable()
export class UserSupportingCompanyFacade {
  private readonly store = inject<Store<AppState>>(Store);
  private readonly actions = inject(Actions);

  public loadingCompaniesSupportedByUser$ = this.store.select(uscSelectors.selectLoadingCompaniesSupportedByUser);
  public companiesSupportedByUser$ = this.store.select(uscSelectors.selectCompaniesSupportedByUser);

  public loadingUsersSupportingCompany$ = this.store.select(uscSelectors.selectLoadingUsersSupportingCompany);
  public usersSupportingCompany$ = this.store.select(uscSelectors.selectUsersSupportingCompany);

  public updateInProgress$ = this.store.select(uscSelectors.selectUpdateInProgress);
  public errorMessage$ = this.store.select(uscSelectors.selectErrorMessage);

  public updateError$ = this.actions.pipe(ofType(uscActions.updateSupportingCompanyOfUserError));
  public updateSuccess$ = this.actions.pipe(ofType(uscActions.updateSupportingCompanyOfUserSuccess));

  public getCompaniesSupportedByUser(opts: { userId: string }): void {
    this.store.dispatch(uscActions.getCompaniesSupportedByUser(opts));
  }

  public getUsersSupportingCompany(opts: { companyId: string }): void {
    this.store.dispatch(uscActions.getUsersSupportingCompany(opts));
  }

  public updateSupportingCompanyOfUser(opts: UpdateUserSupportingCompanyOpts): void {
    this.store.dispatch(uscActions.updateSupportingCompanyOfUser({ opts }));
  }
}
